import ipad from '@/assets/playturbo/device/device-ipad.png'
import iphone6 from '@/assets/playturbo/device/device-iphone6.png'
import iphonex from '@/assets/playturbo/device/device-iphonex.png'
import redmi from '@/assets/playturbo/device/device-redmi.png'
import vivo from '@/assets/playturbo/device/device-vivo.png'

export const devices = [
  {
    value: 1,
    label: 'iPhoneX',
    desc: '(828x1792)',
    src: iphonex,
    width: 984 / 3, // 图片宽度
    height: 1933 / 3, // 图片高度
    innerWidth: 828 / 3, // 手机内部尺寸宽度
    innerHeight: 1792 / 3, // 手机内部尺寸高度
    frameWidth: 375, // 屏幕宽度
    frameHeight: 734 // 屏幕高度
  },
  {
    value: 2,
    label: 'iPad',
    desc: '(768x1024)',
    src: ipad,
    width: 872 / 2, // 图片宽度
    height: 1224 / 2, // 图片高度
    innerWidth: 768 / 2, // 手机内部尺寸宽度
    innerHeight: 1024 / 2, // 手机内部尺寸高度
    frameWidth: 768, // 屏幕宽度
    frameHeight: 1024 // 屏幕高度
  },
  {
    value: 3,
    label: 'iPhone6',
    desc: '(750x1334)',
    src: iphone6,
    width: 924 / 3, // 图片宽度
    height: 1780 / 3, // 图片高度
    innerWidth: 750 / 3, // 手机内部尺寸宽度
    innerHeight: 1334 / 3, // 手机内部尺寸高度
    frameWidth: 750 / 2, // 屏幕宽度
    frameHeight: 1334 / 2 // 屏幕高度
  },
  {
    value: 4,
    label: 'redmi',
    desc: '(720x1280)',
    src: redmi,
    width: 836 / 3, // 图片宽度
    height: 1621 / 3, // 图片高度
    innerWidth: 720 / 3, // 手机内部尺寸宽度
    innerHeight: 1280 / 3, // 手机内部尺寸高度
    frameWidth: 720 / 2, // 屏幕宽度
    frameHeight: 1280 / 2 // 屏幕高度
  },
  {
    value: 5,
    label: 'vivo',
    desc: '(1080x2280)',
    src: vivo,
    width: 1200 / 4, // 图片宽度
    height: 2435 / 4, // 图片高度
    innerWidth: 1080 / 4, // 手机内部尺寸宽度
    innerHeight: 2320 / 4, // 手机内部尺寸高度
    frameWidth: 1080 / 3, // 屏幕宽度
    frameHeight: 2150 / 3 // 屏幕高度
  }
]
